module.exports = __webpack_public_path__ + "assets/img/2612.e99226d5.png";